// Feature detection. The API needs to be supported
// and the app not run in an iframe.
export const supportsFileSystemAccess =
  'showDirectoryPicker' in window &&
  (() => {
    try {
      return window.self === window.top;
    } catch (_) {
      return false;
    }
  })();

export const openDirectoryWebkitInput = async (): Promise<FileList | undefined> =>
  // Fallback if the File System Access API is not supported.
  new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.webkitdirectory = true;
    input.multiple = true;

    input.addEventListener('change', () => {
      const files: FileList = (input as any).files;
      resolve(files);
    });
    if ('showPicker' in HTMLInputElement.prototype) {
      input.showPicker();
    } else {
      input.click();
    }
  });

export const openDirectoryApi = async (mode = 'read', igoreList: string[] = []): Promise<FileList | undefined> => {
  if (!supportsFileSystemAccess) {
    alert('ShowDirectoryPicker is not supported in browser');
    return;
  }
  let directoryStructure: any;
  // Recursive function that walks the directory structure.
  const getFiles = async (dirHandle: FileSystemDirectoryHandle, path = dirHandle.name) => {
    const dirs: any[] = [];
    const files: File[] = [];
    for await (const entry of (dirHandle as any).values()) {
      const nestedPath = `${path}/${entry.name}`;
      if (entry.kind === 'file' && igoreList.includes(entry.name)) {
        console.warn(`File was ignored: "${nestedPath}"`);
        continue;
      }
      console.log(`ENTRY: ${entry.kind} "${entry.name}"`);
      if (entry.kind === 'file') {
        files.push(
          entry.getFile().then((file: any) => {
            file.directoryHandle = dirHandle;
            file.handle = entry;
            return Object.defineProperty(file, 'webkitRelativePath', {
              configurable: true,
              enumerable: true,
              get: () => nestedPath,
            });
          }),
        );
      } else if (entry.kind === 'directory') {
        dirs.push(getFiles(entry, nestedPath));
      }
    }
    return [...(await Promise.all(dirs)).flat(), ...(await Promise.all(files))];
  };

  try {
    // Open the directory.
    const handle = await (window as any).showDirectoryPicker({
      mode,
    });
    // Get the directory structure.
    directoryStructure = getFiles(handle, undefined);
  } catch (err: any) {
    if (err.name !== 'AbortError') {
      console.error(err.name, err.message);
    }
  }
  return directoryStructure;
};
